import React, { useEffect, useState } from 'react'
import { AppState, TransactionStatus } from '../../../store/types/appState'
import { useDispatch, useSelector } from 'react-redux'
import useLoadStripe from '../../../hooks/useLoadStripe'
import { Elements } from '@stripe/react-stripe-js'
import Loader from '../../ui/Loader/Loader'
import StripePaymentElementsForm from './StripePaymentElementsForm'
import { createPaymentIntent } from '../../../store/actions/stripe'
import classes from './StripePaymentElementsFormWrapper.module.css'
import logo from '../../../assets/stripe_blurple.svg'
import { currencyFormat } from '../../../utils/utils'
import { useTranslation } from 'react-i18next'

export type Props = {
	back: () => void
}

const StripePaymentElementsFormWrapper = (props: Props) => {
	const [isReady, setIsReady] = useState(false)
	const dispatch = useDispatch()

	const paymentIntentClientSecret = useSelector<AppState, string>((state) => state.stripe.paymentIntentClientSecret)
	const transactionStatus = useSelector<AppState, TransactionStatus>((state) => state.transaction.status)

	const { i18n } = useTranslation()
	const currencyCode = useSelector<AppState, string | undefined>(
		(state) => state.merchant.configuration?.currencyCode
	)

	const amount = currencyFormat(
		useSelector<AppState, number>((x) => x.transaction.amount),
		i18n.language,
		currencyCode
	)
	const locationName = useSelector<AppState, string | null>((state) => state.transaction.locationName)
	const areaName = useSelector<AppState, string | null>((state) => state.transaction.areaName)
	const address = useSelector<AppState, string | null>((state) => state.transaction.address)

	useEffect(() => {
		if (!paymentIntentClientSecret && transactionStatus === TransactionStatus.Pending) {
			dispatch(createPaymentIntent())
		}
	}, [dispatch, paymentIntentClientSecret, transactionStatus])

	const isLoading = useSelector<AppState, boolean>((state) => state.stripe.loading)

	const { stripePromise } = useLoadStripe()

	return (
		<div className={classes.payment_container}>
			{/* Amount */}
			<div className={classes.amount}>{amount}</div>

			{/* Location */}
			<div className={classes.location_block}>
				<div className={classes.location_title}>
					{locationName} – {areaName}
				</div>
				<div className={classes.location_address}>{address}</div>
			</div>

			<hr className={classes.divider} />

			{/* Loader */}
			{(isLoading || !isReady) && <Loader />}

			{/* Stripe elements */}
			{paymentIntentClientSecret !== '' && (
				<Elements options={{ clientSecret: paymentIntentClientSecret }} stripe={stripePromise}>
					<StripePaymentElementsForm onReady={() => setIsReady(true)} back={props.back} />
				</Elements>
			)}

			{/* Powered by Stripe */}
			<div className={classes.powered_by}>
				<img className={classes.stripe_logo} src={logo} alt='Stripe' />
			</div>
		</div>
	)
}

export default StripePaymentElementsFormWrapper
